module.exports = __webpack_public_path__ + "img/samaracentro.e1a329ca.png";